import { Component, inject } from '@angular/core';
import { StagePerProcessService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StagePerProcessCreateDto,
  StagePerProcessDto,
  StagePerProcessExcelDownloadDto,
  StagePerProcessUpdateDto,
} from '../proxy/controlling/dtos/stage-per-process';
import { STAGEPERPROCESS_CONFIG, STAGEPERPROCESS_FIELDS } from './stage-per-process.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-stage-per-process',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StagePerProcessService, ConfirmationService],
  templateUrl: './stage-per-process.html',
  styleUrl: './stage-per-process.scss',
})
export class StagePerProcess extends BaseCrudComponent<
  StagePerProcessDto,
  StagePerProcessCreateDto,
  StagePerProcessUpdateDto,
  StagePerProcessExcelDownloadDto
> {
  service = inject(StagePerProcessService);
  config = STAGEPERPROCESS_CONFIG;
  fields = STAGEPERPROCESS_FIELDS;

  protected prepareUpdateDto(data: any, selected: StagePerProcessDto): StagePerProcessUpdateDto {
    return {
      stageId: data.stageId,
      processId: data.processId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StagePerProcess';
  }
}
